"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_ITEM_MARGIN = exports.MENU_ITEM_OPENED_HEIGHT = exports.MENU_ITEM_CLOSED_HEIGHT = exports.MENU_ITEM_OPENED_WIDTH = exports.MENU_ITEM_CLOSED_WIDTH = void 0;
exports.MENU_ITEM_CLOSED_WIDTH = 80;
exports.MENU_ITEM_OPENED_WIDTH = 320;
exports.MENU_ITEM_CLOSED_HEIGHT = 72;
exports.MENU_ITEM_OPENED_HEIGHT = 48;
exports.MENU_ITEM_MARGIN = 4;
